import Table, { TableColumns } from "../../../components/table";

interface SingleEnterpriseWctLoanTableProps {
  loading: boolean;
  title: string;
  columns: TableColumns[];
  data: {
    _id: JSX.Element;
    appId: JSX.Element;
    approvedAmount: number;
    irpa: number;
  }[];
}

export default function SingleEnterpriseWctLoanTable({
  loading,
  title,
  columns,
  data,
}: SingleEnterpriseWctLoanTableProps) {
  return (
    <div className="dashboard-container">
      <h3 className="user-page-title mb-4">{title}</h3>
      <Table loading={loading} columns={columns} data={data} />
    </div>
  );
}
